/**
 * Count-agreed copy for anything a user reads.
 *
 * The Interview Intelligence toasts read "Attached 1 interviews" and "Loaded 1 interviews"
 * on a project with a single transcript (Asana 1218245820990747). Both were built by
 * interpolating a count straight into a hardcoded plural noun, which is right for every
 * value except the one a first-time project actually has.
 *
 * `countOf` mirrors the `count()` helper in the report renderer
 * (backend/src/services/interviewIntelligence/reportRenderer.js) deliberately — the toast
 * and the report it announces should not disagree about how to say the same number.
 */

/**
 * A count and the noun it counts, agreeing: "1 interview", "6 interviews".
 *
 * A non-numeric count — the `?` these call sites fall back to when the API answers without
 * a count — takes the plural, because an unknown quantity is not one thing.
 */
export function countOf(
  n: number | string | null | undefined,
  singular: string,
  plural?: string,
): string {
  const isOne = typeof n === 'number' && n === 1;
  return `${n ?? '?'} ${isOne ? singular : (plural ?? `${singular}s`)}`;
}

/** The form of a verb or pronoun that agrees with a count: was/were, is/are, it/them. */
export function agree(n: number | string | null | undefined, singular: string, plural: string): string {
  return typeof n === 'number' && n === 1 ? singular : plural;
}
